<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat poskytovatele reklam' | translate" route-name="advertisingProviderNew" />
      <h1 v-translate>Poskytovatelé reklam</h1>
    </div>
    <div class="inner_white">
      <div class="filter search_only">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search" />
        </div>
      </div>

      <div class="table_overflow" id="contentBox" data-table-id="advertising-providers-list">
        <table class="vypis vypis_detail">
          <thead>
          <tr v-if="entities.length > 0">
            <th class="no_padding drag_drop" />
            <th class="no_padding checkbox" />
            <sorting-table-title
                v-for="title in advertisingProvidersTableTitles"
                :key="title.key"
                :column="title.column"
                :sort="getActiveSort(title.column)"
                @changeSorting="changeSorting"
            >{{ title.name }}</sorting-table-title>
            <th class="no_padding edit" />
          </tr>
          </thead>

          <tbody>
            <advertising-provider-row
                v-for="provider in entities"
                :entity="provider"
                :key="provider.id"
                :selectedProviders="selectedEntities"
                :ref="'provider-row-ref-'+provider.id"
                @deleteProvider="deleteEntity"
                @input="select"
            ></advertising-provider-row>

            <tr v-if="entities.length === 0">
              <td colspan="8" v-translate>Nebyli nalezeni žádní poskytovatelé reklam</td>
            </tr>
          </tbody>
        </table>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="advertising-providers-list"
          @run-multiple-action="executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          @select-all="toggleSelectAll"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import AdvertisingProviderRow from "@/components/views/advertisingProviders/AdvertisingProviderRow"
import listActions from "@/components/mixins/list-actions"

export default {
  name: 'AdvertisingProvidersList',
  components: {
    AdvertisingProviderRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'advertisingProviders',
      entitiesKey: 'advertisingProviders',
      dateFields: ['created_from', 'created_to', 'last_start_from', 'last_start_to'],
      formFields: {
        search: null,
        sort: {
          column: 'sName',
          direction: 'desc',
        },
        created_from: null,
        created_to: null,
        last_start_from: null,
        last_start_to: null,
      },
    }
  },
  created(AdvertisingProviderService) {
    this.entityService = AdvertisingProviderService;

    this.createdInit()
  },
  computed: {
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
    advertisingProvidersTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Kód'), column: 'sCode'},
        {key: 3, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
        {key: 4, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ];
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.advertisingProvidersTableTitles)
    },
  },
  methods: {
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.deleteEntity(actionIds);
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('created_from')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('created_to')) {
        anyChanges = true
      }
      return anyChanges
    },
    saveFilterValues() {
      this.setUserSetting('name', this.formFields.name);
      this.setUserSetting('code', this.formFields.code);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/AdvertisingProvidersList.vue